import { render, staticRenderFns } from "./publishVote.vue?vue&type=template&id=c137794a&scoped=true&"
import script from "./publishVote.vue?vue&type=script&lang=js&"
export * from "./publishVote.vue?vue&type=script&lang=js&"
import style0 from "./publishVote.vue?vue&type=style&index=0&id=c137794a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c137794a",
  null
  
)

export default component.exports